import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";

export default function Gallery() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const cats = ["all", ...Array.from(new Set(items.map((i) => i.category)))];
  const shown = filter === "all" ? items : items.filter((i) => i.category === filter);
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("home.gallery_title")}</h1>
      <div className="mt-6 flex flex-wrap gap-2">
        {cats.map((c) => (
          <button key={c} onClick={() => setFilter(c)} data-testid={`gallery-filter-${c}`} className={`rounded-full px-4 py-2 text-sm font-medium capitalize transition-colors ${filter === c ? "bg-primary text-white" : "border border-border bg-white text-slate-600"}`}>{c === "all" ? t("common.all") : c}</button>
        ))}
      </div>
      <div className="mt-8 columns-2 gap-4 md:columns-3">
        {shown.map((g) => (
          <div key={g.id} className="mb-4 break-inside-avoid overflow-hidden rounded-xl">
            <img src={g.image} alt="" className="w-full object-cover transition-transform duration-500 hover:scale-105" />
          </div>
        ))}
      </div>
    </div>
  );
}
